import Link from '../../elements/Link';
import {SanityLink} from '../../../types';

type Props = {
  links: SanityLink[];
  onClose: () => void;
};

export default function LegalsFooterGroupContent({links, onClose}: Props) {
  return (
    <div className="grid grid-cols-4 gap-5 pb-footer">
      <div className="hidden xl:block xl:col-span-3"></div>
      <div className="col-span-4 xl:col-span-1 grid grid-cols-2">
        <ul>
          {links.map((link) => 
            <li key={link._key}>
              <Link
                link={link}
                className="text-gray hover:text-main !normal-case"
                onClick={onClose}
              >
                {link.title}
              </Link>
            </li>
          )}
        </ul>
        <div className="text-right">
          <p className="text-black">
            Design,<br/>
            Developement<br/>
            & Maintenance
          </p>
          <a
            href="https://www.instagram.com/benito.cool/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray hover:text-main"
          >
            benito.cool
          </a>
        </div>
      </div>
    </div>
  );
}